import React from 'react'

export const IngredientName: React.FC<{item:string, bought: boolean}> = ({item, bought}) => {
  return (
    <p className={`text-[14px] leading-[18px] font-medium cursor-normal ${bought ? 'text-gray-300 line-through' : 'text-primary'}`}>{item}</p>
  )
}
